<template>
    <span v-show="message" class="text-xs text-red-600 dark:text-red-400">
        {{ message }}
    </span>
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: ['message']
    })
</script>
